/*
 * Copyright (c) 2025 Frayo and HomeChef360. All Rights Reserved.
 *
 * CONFIDENTIAL & PROPRIETARY
 * This software and its source code are the confidential and proprietary
 * information of Frayo and HomeChef360. Unauthorized copying, modification,
 * distribution, disclosure, or use of this code, in whole or in part, via any
 * medium, is strictly prohibited without prior written consent.
 *
 * Violations will be subject to legal action in the State of Florida and may
 * also be pursued under applicable U.S. federal law.
 */

import React from "react";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import App from "../App";
import { ErrorPage } from "../features/ErrorPage";
import SubscriptionPage from "../modules/subscription/SubscriptionPage";
import PaymentSuccess from "../modules/subscription/files/Success";
import PaymentCancel from "../modules/subscription/files/Paymentcancel";
import SubscriptionForm from "../modules/subscription/files/TrialPlan";
import SalesPageUserPromoteKit from "../modules/subscription/files/SalesPageUserPromoteKit";
import UserPromoteKitSuccess from "../modules/subscription/files/UserPromoteKitSuccess";
import SalesPageChefsPromoteKit from "../modules/subscription/files/SalesPageChefsPromoteKit";
import ChefsPromotekitSuccess from "../modules/subscription/files/ChefsPromoteKitSuccess";
import PromoteKitScript from "../PromoteKitScript";
import ChooseSubscriptionPage from "../modules/subscription/files/ChooseSubscriptionPage";
import WelcomePage from "../modules/subscription/files/WelcomePage";
import CancelUserPK from "../modules/subscription/files/CancelUserPK";
import CancelChefPK from "../modules/subscription/files/CancelChefPK";
import StudentVerification from "../modules/subscription/files/StudentVerification";
import StudentSubscription from "../modules/subscription/files/studentSubscription";
import SubscriptionDetailsPage from "../modules/subscription/files/SubscribeModal";

function AppRoutes() {
  return (
    <BrowserRouter>
      <Routes>
        {/* Main App Layout */}
        <Route element={<App />}>
          {/* Public Routes */}
          <Route path="error/*" element={<ErrorPage />} />
          <Route path="subscriptions/:id" element={<SubscriptionPage />} />
           <Route path="/subscription/checkout/:id" element={<SubscriptionDetailsPage />} />

          <Route path="subscriptions/" element={<SubscriptionPage />} />
          <Route path="payment-success/*" element={<PaymentSuccess />} />
          <Route path="payment-cancel/*" element={<PaymentCancel />} />
          <Route path="trial-plan/*" element={<SubscriptionForm />} />
          <Route path="student-verification/:id" element={<StudentVerification />} />
          <Route path="student-subscription/:id" element={<StudentSubscription />} />
          <Route path="/subscription/*" element={<ChooseSubscriptionPage />} />
          <Route path="/*" element={<WelcomePage />} />
          {/* user promote kit */}
          <Route path="subscription/users" element={
            <>
              <PromoteKitScript />
              <SalesPageUserPromoteKit />
            </>
          } />
          <Route path="pk/user-promotekit-success" element={
            <>
              <PromoteKitScript />
              <UserPromoteKitSuccess />
            </>
          } />
          <Route path="pk/user-promotekit-cancel" element={
            <>
              <PromoteKitScript />
              <CancelUserPK />
            </>
          } />
          {/* chef promote kit */}
          <Route path="subscription/chefs" element={
            <>
              <PromoteKitScript />
              <SalesPageChefsPromoteKit />
            </>
          } />
          <Route path="pk/chefs-promotekit-success" element={
            <>
              <PromoteKitScript />
              <ChefsPromotekitSuccess />
            </>
          } />
          <Route path="pk/chefs-promotekit-cancel" element={
            <>
              <PromoteKitScript />
              <CancelChefPK />
            </>
          } />
          {/* Catch-All Route */}
          <Route path="/*" element={<WelcomePage />} />
        </Route>
      </Routes>
    </BrowserRouter>
  );
}

export default AppRoutes;
